import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Reducers
import rootReducer from './reducer';
import themeSettingSlice from './themeSettingSlice';

// Persist only 'user_infos' inside the 'root' reducer
const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: ['user_infos', 'user_location', 'current_location'], // Specify which parts of the state to persist
};

const combinedReducer = combineReducers({
  rootReducer: persistReducer(rootPersistConfig, rootReducer),
  themeSetting: themeSettingSlice,
});

const store = configureStore({
  reducer: combinedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
